import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60d50cca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=60d50cca&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=60d50cca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d50cca",
  null
  
)

export default component.exports